<template>
  <el-header class="header">
    <h1>{{ configureInfos.name }}</h1>
    <div class="user flex flex_x_bten">
      <div class="flex flex_x_bten">
        <div class="headImg">
          <el-avatar shape="square" :src="squareUrl"></el-avatar>
        </div>
        <el-dropdown placement="bottom-start">
          <span class="el-dropdown-link c_fff">
            {{ content.administrator }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link :to="{ path: '/password?title=修改密码' }">修改密码</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <button class="drop-out c_fff" @click="handleLogout">退出</button>
    </div>
  </el-header>
</template>

<script>
export default {
  data() {
    return {
      squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      content: {}
    };
  },
  created() {
    this.backEndHome();
    this.requestMerchData(); // 获取商户数据
    this.requestServiceList(); // 获取服务商列表
    this.requestAgentInfo(); // 获取代理商列表
    this.requestPlatformList(); // 获取平台列表

  },
  methods: {
    handleLogout() {
      let _this = this;
      tipsTemplate("是否退出登录?", "warning", "3", "确定", async function () {
        let datum = await _this.service.User.LogOut();
        if (datum.code == 0) {
          _this.$router.replace("/");
          sessionStorage.setItem("token", "");
          sessionStorage.setItem("optionBtn", "");
          sessionStorage.setItem("btn_list", "");
          sessionStorage.setItem("detailInfo", "");
        } else {
          tipsTemplate(datum.msg, "error", "1");
        }
      });
    },
    async backEndHome() {
      // 后台首页
      let details = await this.service.User.HomePageList();
      if (details.code == 0) {
        this.content = details.data;
      }
    },
    /*
    * Function: requestMerchData()
    * Desc: 获取商户数据
    * Date: 2022-01-11
    * Author: jxx
    * */
    async requestMerchData() {
      // 获取商户接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 1 });
      if (details.code == 0) {
        // 商户列表
        sessionStorage.setItem("merchList", JSON.stringify(details.data))
      } else {
        // 获取商户接口失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    },
    /*
    * Function: requestServiceList()
    * Desc: 获取服务商列表
    * Date: 2023-12-26
    * Author: jxx
    * */
    async requestServiceList() {
      // 获取服务商接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 2 });
      if (details.code == 0) {
        // 服务商列表
        sessionStorage.setItem("serviList", JSON.stringify(details.data));
      } else {
        // 接口调用失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    },
    /*
    * Function: requestAgentInfo()
    * Desc: 获取代理商信息
    * Date: 2022-01-11
    * Author: jxx
    * */
    async requestAgentInfo() {
      // 获取代理商信息接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 3 });
      if (details.code == 0) {
        // 代理商列表
        sessionStorage.setItem("agentList", JSON.stringify(details.data));
      } else {
        // 接口调用失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    },
    /*
* Desc: 获取平台列表
* */
    async requestPlatformList() {
      let platformInfo = await this.service.sellerinfo.AgentSelectList({type: 7});
      if (platformInfo.code == 0) {
        sessionStorage.setItem("platformList", JSON.stringify(platformInfo.data));
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.el-header {
  position: relative;
  z-index: 2000;
  height: 60PX !important;
  line-height: 60PX;
  background-color: #012953;

  /* h1 标题 */
  h1 {
    line-height: 50px;
    font-size: 20px;
    text-align: right;
    padding-right: 10px;
    margin-left: -6px;
    display: inline-block;
    color: #ffffff;
  }

  .user {
    float: right;
    // width: 200px;
    height: 60PX;
    line-height: 60PX;

    .headImg {
      margin: 10px 15px 10px 0;
    }

    .el-dropdown {
      // width: 100px;
      line-height: 60PX;
      cursor: pointer;
    }
  }

  .drop-out {
    width: 50px;
    cursor: pointer;
    font-size: 14px;
  }
}

/deep/.el-dropdown-menu {
  z-index: 3008 !important;
  width: 120px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/comHeader.vue